<!--
 * @Author: zhangmh31513
 * @Date: 2021-09-15 10:47:52
 * @LastEditTime: 2021-11-05 09:48:39
 * @LastEditors: zhangmh31513
 * @Description: 光子乐园挂件
 * @FilePath: \openplat-web\src\gtn\views\frontViews\developerConference\components\cooperateIcon.vue
 * 有问题请第一时间来联系我
-->

<template>
  <div class="cooperate-icon" @click="jumpDetail"></div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "CooperateIcon",
  computed: {
    ...mapGetters(["hsid"])
  },
  methods: {
    // 跳转到光子乐园
    jumpDetail() {
      const pageName_var = this.$route.name;
      this.gioTrackEvent("LDC_photonPendantClick", {
        pageName_var,
        deviceType_var: "Web",
        hsUserId_var: this.hsid || "-"
      });
      window.open(window.LOCAL_CONFIG.PHOTON_URL, "_blank");
    }
  }
};
</script>
<style lang="scss" scoped>
.cooperate-icon {
  z-index: 999;
  position: fixed;
  right: 1%;
  bottom: 10%;
  width: 100px;
  height: 230px;
  background: url("../../../../assets/developerConference/widget.gif");
  cursor: pointer;
  background-size: cover;
}
@media (max-width: 1366px) {
  .cooperate-icon {
    width: 50px;
    height: 130px;
  }
}
@media (min-width: 1366px) and (max-width: 1600px) {
  .cooperate-icon {
    width: 80px;
    height: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/components/cooperateIcon.vue